// Karta jednoho školení v přehledu (16. 10. 2026, schválený mockup): fialová hlavička s názvem
// a štítky, dole postup a tlačítko, které otevře školení v okně přes celou obrazovku.
import React from "react";
import { Play } from "lucide-react";

export default function SkoleniKarta({ nazev, stitky, children, tlacitko, onOtevrit }) {
  return (
    <div className="glass min-w-0 overflow-hidden !p-0">
      <button type="button" onClick={onOtevrit} aria-label={`Otevřít školení ${nazev}`}
        className="flex w-full items-center gap-3 bg-gradient-to-r from-brand-950 via-brand-900 to-brand-700 px-4 py-3 text-left text-white sm:px-5">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/20"><Play className="h-5 w-5" /></span>
        <span className="min-w-0 flex-1">
          <span className="block font-serif text-lg font-bold leading-tight">{nazev}</span>
          <span className="mt-1 flex flex-wrap gap-1.5">{stitky}</span>
        </span>
      </button>
      <div className="space-y-3 px-4 py-3 sm:px-5">
        {children}
        <button type="button" className="btn btn-primary" onClick={onOtevrit}>{tlacitko || "Otevřít"}</button>
      </div>
    </div>
  );
}

export function Stitek({ children }) {
  return <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-white/20 px-2 py-0.5 text-[11px] font-bold text-white">{children}</span>;
}

export function PruhPostupu({ hotovo, celkem }) {
  const p = celkem ? Math.round((hotovo / celkem) * 100) : 0;
  return (
    <div>
      <div className="mb-1 flex items-center justify-between text-[12px] font-semibold text-slate-500"><span>Postup</span><span>{hotovo} z {celkem} modulů</span></div>
      <div className="h-2 overflow-hidden rounded-full bg-slate-100" role="progressbar" aria-valuenow={p} aria-valuemin={0} aria-valuemax={100}>
        <div className="h-full rounded-full bg-emerald-500 transition-all" style={{ width: `${p}%` }} />
      </div>
    </div>
  );
}

export const datumCz = (d) => { const x = new Date(d); return Number.isNaN(x.getTime()) ? "" : `${x.getDate()}. ${x.getMonth() + 1}. ${x.getFullYear()}`; };
